import React, {useEffect, useRef, useState} from "react";
import "./style.scss";
import {getPlayerTimeByAbsoluteTime, rangeLimit} from "../../../../../common/src";
import { getStreamSessions } from "../../../../../common/src/stream";

const EpisodeMark = ({episode, stream, streamDay, playerDuration, timeOffset = 0}) => {

    const sessions = getStreamSessions(stream);
    const playerTimeStart = getPlayerTimeByAbsoluteTime(episode.timeStart, sessions, streamDay, stream.timeStart) - timeOffset;
    const playerTimeStop = getPlayerTimeByAbsoluteTime(episode.timeStop, sessions, streamDay, stream.timeStart) - timeOffset;
    let playerPercentStart = playerTimeStart / playerDuration * 100;
    let playerPercentStop = playerTimeStop / playerDuration * 100;

    if (playerPercentStart > 100 || playerPercentStop < 0) return null;

    playerPercentStart = playerPercentStart < 0 ? 0 : playerPercentStart;
    playerPercentStop = playerPercentStop > 100 ? 100 : playerPercentStop;

    const style = {
        left: playerPercentStart + '%',
        width: (playerPercentStop - playerPercentStart) + '%',
    };

    return (
        <div style={style} />
    );
}

export default ({currentTime, episode, duration, isLive, stream, streamDay, streamEpisodes, onChange, onHintPositionChange, sliderRef, timeOffset}) => {
    const [dragPosition, setDragPosition] = useState(null);
    if (!sliderRef) {
        sliderRef = useRef(null);
    }

    const handleDragStart = (e) => {
        setDragPosition(duration ? currentTime / duration : 0);
        addDragEvents();
        handleDragMove(e);
    };
    const handleDragMove = (e) => {
        const sliderRect = sliderRef.current.getBoundingClientRect();
        const pageX = ((e.type === 'touchstart' || e.type === 'touchmove') ? e.changedTouches[0] : e).pageX;
        const position = rangeLimit(pageX - sliderRect.left, 0, sliderRect.width) / sliderRect.width;
        setDragPosition(position);
        onChange(position * duration);
    }
    const handleDragStop = () => {
        setDragPosition(null);
        removeDragEvents();
    }

    const handleMouseMove = (e) => {
        const sliderRect = sliderRef.current.getBoundingClientRect();
        const pageX = ((e.type === 'touchstart' || e.type === 'touchmove') ? e.changedTouches[0] : e).pageX;
        const position = rangeLimit(pageX - sliderRect.left, 0, sliderRect.width) / sliderRect.width;
        onHintPositionChange(position);
    }
    const handleMouseLeave = () => {
        onHintPositionChange(null);
    }

    const addDragEvents = () => {
        window.addEventListener('mousemove', handleDragMove);
        window.addEventListener('touchmove', handleDragMove);
        window.addEventListener('mouseup', handleDragStop);
        window.addEventListener('touchend', handleDragStop);
    }
    const removeDragEvents = () => {
        window.removeEventListener('mousemove', handleDragMove);
        window.removeEventListener('touchmove', handleDragMove);
        window.removeEventListener('mouseup', handleDragStop);
        window.removeEventListener('touchend', handleDragStop);
    }

    useEffect(() => {
        return removeDragEvents;
    }, []);

    let position = duration > 0 ? currentTime / duration * 100 : 0;
    if (isLive) {
        position = 100;
    }
    if (null !== dragPosition) {
        position = dragPosition * 100;
    }
    const className = 'stream-player-progressBar';

    return (
        <div
            className={className}
            ref={sliderRef}
            onMouseDown={handleDragStart}
            onTouchStart={handleDragStart}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
        >
            <div className={`${className}-fill`} style={{width: position + '%'}}></div>
            <div className={`${className}-point`} style={{left: position + '%'}} />
            <div className={`${className}-track`}>
                {!episode && streamEpisodes?.filter(episode => !episode.delay).map((episode) => (
                    <EpisodeMark
                        key={episode.id}
                        episode={episode}
                        stream={stream}
                        streamDay={streamDay}
                        playerDuration={duration}
                        timeOffset={timeOffset}
                    />
                ))}
            </div>
        </div>
    );
}
